import log from 'salvo-lite/log'
import axios from 'axios'

class LoadMore {
    constructor (theme, elem) {
        log.debug('LoadMore', 'Constructing', this)
        this._elem = elem
        this._theme = theme
        this._loadMoreContainer = this._elem.querySelector('[data-load-more-container]')
        this._settings = this._elem.dataset.loadMore ? JSON.parse(this._elem.dataset.loadMore) : {}
        this._loadMoreButton = this._elem.querySelector('[data-load-more-button]')
        this._loadMoreGrid = this._elem.querySelector('[data-load-more-items]')
        this._progressBarContainer = this._elem.querySelector('[data-progress-bar-container]')
        this.offset = 50
        this.events = this.createEvents()
        this._isLoading = false
    }

    createEvents () {
        return {
            loaded: (data) => {
                return new CustomEvent('loaded-more-items', {
                    detail: data
                })
            }
        }
    }

    onInit () {
        log.debug('LoadMore', 'Initiating')
        if (!this._loadMoreContainer) return false
        this._loadMoreButton.addEventListener('click', e => {
            e.preventDefault()
            this.loadMore()
        })
        if (this._settings.infiniteScroll) {
            this.scrollEvent()
        }
        log.debug('LoadMore', 'Initiated')
    }

    scrollEvent () {
        window.addEventListener('scroll', (e) => {
            if (this._loadMoreContainer && (window.scrollY + window.innerHeight + this.offset) >= this._loadMoreContainer.offsetTop) {
                if (!this._isLoading) {
                    this.loadMore()
                }
            }
        })
    }

    loadMore () {
        if (this._isLoading || !this._loadMoreButton) return false
        let originalContent = this._loadMoreButton.textContent
        log.debug('LoadMore', 'Load More Trigger Clicked!')
        let url = this._loadMoreButton.dataset.loadMoreUrl
        this._isLoading = true
        this._loadMoreButton.setAttribute('disabled', 'disabled')
        this._loadMoreButton.textContent = 'Loading...'
        this._loadMoreContainer.classList.add('loading')
        axios.get(url)
            .then((response) => {
                console.log(response)

                let resp = response.data
                let parser = new DOMParser()
                let html = parser.parseFromString(resp, 'text/html')

                let data = html.querySelectorAll('[data-load-more-items] > *')
                let fragment = document.createDocumentFragment()

                for (let dataItem of data) {
                    fragment.appendChild(dataItem)
                    dataItem.setAttribute('data-unitialized-item', true)
                }

                this._loadMoreGrid.appendChild(fragment)

                let newItems = this._loadMoreGrid.querySelectorAll('[data-unitialized-item]')

                let wishlistElems = this._loadMoreGrid.querySelectorAll('[data-unitialized-item] [data-wishlist-outer]')
                window.esc_wishlist = window.esc_wishlist || []
                window.esc_wishlist.push(api => {
                    wishlistElems = Array.apply(null, wishlistElems)
                    api.emit('initialize', wishlistElems)
                })

                for (let newItem of newItems) {
                    this._theme.registerComponents(newItem)
                    newItem.removeAttribute('data-unitialized-item')
                }

                this._loadMoreContainer.classList.remove('loading')

                let loadMoreButton = html.querySelector('[data-load-more-container] [data-load-more-button]')
                let progressBarContainer = html.querySelector('[data-progress-bar-container]')

                if (loadMoreButton) {
                    this._loadMoreButton.dataset.loadMoreUrl = loadMoreButton.dataset.loadMoreUrl
                } else {
                    this._loadMoreContainer.parentNode.removeChild(this._loadMoreContainer)
                    this._loadMoreContainer = null
                    this._loadMoreButton = null
                }

                if (progressBarContainer) {
                    this._progressBarContainer.innerHTML = progressBarContainer.innerHTML
                }

                this._elem.dispatchEvent(this.events.loaded({ items: newItems }))
                this._loadMoreGrid.dispatchEvent(this.events.loaded({ items: newItems }))
                document.dispatchEvent(new Event('preload-update'))

                if (this._loadMoreButton) {
                    this._loadMoreButton.textContent = originalContent
                    this._loadMoreButton.removeAttribute('disabled')
                }
                this._isLoading = false
            })
            .catch((error) => {
                console.log(error)
                this._loadMoreButton.removeAttribute('disabled')
                this._loadMoreButton.textContent = originalContent
                this._isLoading = false
            })
    }
}

export default LoadMore



// WEBPACK FOOTER //
// ./src/resources/scripts/components/LoadMore.js